/* eslint-disable max-len */
export const output_data = {
  'system_param': [
    { parameter: 'Target Resistivity (MΩ.cm)', val: 0, range: '', status: '', key: 'target_resistivity' },
    { parameter: 'System Product Flow', val: 0, range: '', status: '', key: 'product_flow' },
    // { parameter: 'Flow Per Stack', val: 0, range: '', status: '', key: 'flow_per_stack' },
    { parameter: 'Temperature', val: 0, range: '', status: '', key: 'temperature' },
    { parameter: 'Target Silica Gaurantee (ppb SiO2)', val: 0, range: '', status: '', key: 'target_silica' },
    { parameter: 'Rectifier Efficiency %', val: 0, range: '', status: '', key: 'rect_efficiency' },
    { parameter: 'Rectifier DC Output (Volts)', val: 0, range: '', status: '', key: 'rect_dc_output' },
    { parameter: 'Feed Pressure', val: 0, range: '', status: '', key: 'feed_pressure' }
  ],
  'feed_param': [
    { parameter: 'TEA (ppm as CaCO3)', val: 0, range: '', status: '', key: 'TEA' },
    { parameter: 'TEC (ppm as CaCO3)', val: 0, range: '', status: '', key: 'TEC' },
    { parameter: 'pH', val: 0, range: '', status: '', key: 'ph' },
    { parameter: 'Alkalinity', val: 0, range: '', status: '', key: 'alkalinity' },
    { parameter: 'Hardness', val: 0, range: '', status: '', key: 'hardness' },
    { parameter: 'Fe++', val: 0, range: '', status: '', key: 'Fe' },
    { parameter: 'Mn++', val: 0, range: '', status: '', key: 'Mn' },
    { parameter: 'Boron', val: 0, range: '', status: '', key: 'Boron' },
    { parameter: 'H2S', val: 0, range: '', status: '', key: 'H2S' },
    { parameter: 'Silica (ppb SiO2)', val: 0, range: '', status: '', key: 'silica' },
    { parameter: 'Conductivity (µS/cm @ 25°C)', val: 0, range: '', status: '', key: 'conductivity' },
    { parameter: 'Charge Balance', val: 0, range: '', status: '', key: 'charge_bal' },
  ],
  'feed_water': [
    { ion: 'Ca++', val: 0 }, { ion: 'Mg++', val: 0 }, { ion: 'Na+', val: 0 }, { ion: 'K+', val: 0 }, { ion: 'NH4+', val: 0 },
    { ion: 'Ba++', val: 0 }, { ion: 'Sr++', val: 0 }, { ion: 'Fe++', val: 0 }, { ion: 'Mn++', val: 0 },
    { ion: 'SO4--', val: 0 }, { ion: 'Cl-', val: 0 }, { ion: 'F-', val: 0 }, { ion: 'NO3-', val: 0 },
    { ion: 'Br-', val: 0 }, { ion: 'PO4---', val: 0 }, { ion: 'B-', val: 0 }, { ion: 'SiO2', val: 0 },
    { ion: 'H2S', val: 0 }, { ion: 'HCO3-', val: 0 }, { ion: 'CO2', val: 0 }, { ion: 'CO3--', val: 0 }
  ],
  'calc_param': [
    { parameter: 'Product Flow Rate', val: 0, key: 'product_flow_rate' },
    { parameter: 'Product Resistivity (MΩ.cm)', val: 0, key: 'product_resistivity' },
    { parameter: 'Product Silica Guarantee Level (ppb SiO2)', val: 0, key: 'product_silica_guarantee_level', decimalVal: 0 },
    { parameter: 'Predicted Product Silica Level (ppb SiO2)', val: 0, key: 'pred_pdt_silica', decimalVal: 1 },
    // { parameter: 'Predicted Boron Product (ppb B)', val: 0, key: 'pred_pdt_boron' },
    { parameter: 'Predicted Product Sodium Level (ppb Na)', val: 0, key: 'pred_max_pdt_Na', decimalVal: 1 },
    { parameter: 'Predicted Product Chloride Level (ppb Cl)', val: 0, key: 'pred_max_pdt_Cl', decimalVal: 1 },
    { parameter: 'Predicted Product Sulfate Level (ppb SO4)', val: 0, key: 'pred_max_pdt_SO4', decimalVal: 1 },
    { parameter: 'Maximum Allowable Recovery (%)', val: 0, key: 'max_allowable_recovery', decimalVal: 1 },
    // added new parameter and key for display in Calculated Output Parameters
    { parameter: 'Selected Recovery (%)', val: 0, key: 'selected_recovery', decimalVal: 1 },
    { parameter: '# of E-Cell EDI Stacks', val: 0, key: 'num_stacks' },
    { parameter: 'Current (Amps)', val: 0, key: 'current', decimalVal: 1 },
    { parameter: 'Voltage (Volts)', val: 0, key: 'voltage', decimalVal: 1 },
    { parameter: 'E-Factor', val: 0, key: 'e-factor' },
    { parameter: 'DC power (kW)', val: 0, key: 'dcpower' },
    { parameter: 'AC Power Consumption (kW)', val: 0, key: 'acpower' },
    { parameter: 'AC Energy (kWh/ m3)', val: 0, key: 'acenergy' },
    { parameter: 'Feed Pressure (bar)', val: 0, key: 'feed_pressure', decimalVal: 1 },
    { parameter: 'Predicted Product Outlet Pressure (bar)', val: 0, key: 'pred_pdt_outlet_pressure', decimalVal: 1 },
    { parameter: 'Feed Inlet (m3/h)', val: 0, key: 'feed_inlet', decimalVal: 1 },
    { parameter: 'Concentrate Bleed (m3/h)', val: 0, key: 'concentrate_bleed' },
    { parameter: 'Electrode Bleed (m3/h)', val: 0, key: 'electrode_bleed' }
  ],
  'electrode_gas_gen': [
    { gas: 'H2', units: 'ml/min', exp: '', max: 0 },
    { gas: 'Cl2', units: 'ml/min', exp: '', max: 0 },
    { gas: '', units: 'kg/hr', exp: '', max: 0 },
  ],
  'sizing_for_h2': [
    { title: 'Explosion Limit of H2 in Air', unit: '%', val: 0 },
    { title: 'Design Safety Factor', unit: '%', val: 0 },
    { title: 'Ventilation Blower/Fan Size', unit: 'cmh', val: 0 },
    { title: '', unit: 'cfm', val: 0 }
  ],
  'sizing_for_cl2': [
    { title: 'Exposure Limit of Cl2 in Air', unit: '%', val: 0 },
    { title: 'Design Safety Factor', unit: '%', val: 0 },
    { title: 'Ventilation Blower/Fan Size', unit: 'cmh', val: 0 },
    { title: '', unit: 'cfm', val: 0 }
  ]
};

export const tooltip_data = {
  'prod_rest': 'If a product silica guarantee is required, then a resistivity of 10 MΩ.cm or greater must be selected.',
  'flow_ps': 'Decreasing the flow per stack will increase the maximum TEA or TEC the stack can be fed.  Nominal flow = 22 gpm or 5.0 m3/hr.',
  'rect_eff': 'The rectifier efficiency is based on the rectifier design and the power requirements of the EDI stack(s). The efficiency can be obtained from the rectifier manufacturer, knowing the EDI current and voltage requirements. A typical(default) value is 70%.'
};